import { __rest, __assign } from 'tslib';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { titleize } from '../../utils/titleize.esm.js';

/**
 * Gracefully handles translation when a key may be missing from a messageMap.
 *
 * Use case: Many APIs return tokens that are translated on the client. We know
 * most of these and can translate appropriately, but sometimes an API will
 * return an unexpected token. This util handles the unexpected token gracefully.
 *
 * If all possible values are known, prefer [`FormattedMessage`](https://formatjs.io/docs/react-intl/components#formattedmessage) instead.
 */
function DynamicFormattedMessage(_a) {
    var userFallback = _a.fallback, messageMap = _a.messageMap, token = _a.token, passThrough = __rest(_a, ["fallback", "messageMap", "token"]);
    var message = messageMap[token];
    if (!message) {
        /* istanbul ignore next */
        if (process.env.NODE_ENV === "development") {
            console.trace("Missed translation: \"".concat(token, "\" not found in messageMap."));
        }
        var fallback = userFallback || {
            defaultMessage: titleize(token),
            description: "This is a fallback message and should not be translated.",
            id: "defaultFallback"
        };
        return React.createElement(FormattedMessage, __assign({}, fallback, passThrough));
    }
    return React.createElement(FormattedMessage, __assign({}, message, passThrough));
}

export { DynamicFormattedMessage };
//# sourceMappingURL=DynamicFormattedMessage.esm.js.map
